@import './pk-live-indicator.variables';

:host {
  display: inline-flex;
}

.pk-live-indicator {
  @apply inline-flex items-center justify-between gap-[--live-indicator--gap] rounded-[--live-indicator--border-radius] px-[--live-indicator--padding-x] py-[--live-indicator--padding-y];
  font-family: var(--live-indicator--font-family);

  &--filled {
    @apply bg-[--live-indicator--background];
  }

  &--stroke {
    @apply px-[calc(var(--live-indicator--padding-x)-1px)] py-[calc(var(--live-indicator--padding-y)-1px)];
    @apply [--live-indicator--text:--live-indicator--background];
    @apply [--live-indicator-dot--background:--live-indicator--background];

    &.no-text {
      @apply px-[calc(var(--live-indicator--padding-y)-1px)];
    }
  }
}

.size--m {
  @apply [--live-indicator--gap:--live-indicator-m--gap];
  @apply [--live-indicator--padding-x:--live-indicator-m--padding-x];
  @apply [--live-indicator--padding-y:--live-indicator-m--padding-y];
  @apply [--live-indicator--font-size:--live-indicator-m--font-size];
  @apply [--live-indicator-dot--size:--live-indicator-m-dot--size];
}

.no-text {
  @apply px-[--live-indicator--padding-y];
}

@keyframes live-pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 var(--live-indicator-dot--background);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 calc(var(--live-indicator-dot--size) / 2) rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
